<div class="password-wrapper">
  <div class="password-input-container">
    <input
      #inputField
      pInputText
      id="user-pwd-field"
      name="user-secret-field"
      type="text"
      [value]="value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [ngClass]="{'show-password': showPassword}"
      minlength="8"
      autocomplete="new-password"
      class="{{class}}"
      (input)="onInputChange($event)"
      (focus)="onPasswordFocus()"
      (blur)="onPasswordBlur()"
    />
    <button
      pButton
      type="button"
      class="p-button-text eye-button"
      [icon]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
      [disabled]="disabled"
      (click)="togglePasswordVisibility()"
    >
    </button>
  </div>

  <!-- Password Strength Bar and Requirements -->
  <div
    #overlayPanel
    class="password-overlay p-shadow-4"
    [ngClass]="{'show-above': showOverlayAbove}"
    *ngIf="overlayVisible && showRequirements"
  >
    <div class="password-strength-container" *ngIf="value">
      <div class="password-strength-bar">
        <div
          class="password-strength-fill"
          [ngClass]="strengthClass"
          [style.width.%]="passwordStrength"
        ></div>
      </div>
    </div>

    <h6> {{'UserPages.UserChangePassword.SubtitlePassword' | translate}} </h6>
    <p-divider></p-divider>

    <div class="requirements-list">
      <div class="requirement-item" [ngClass]="{'fulfilled': hasMinLength}">
        <i [class]="hasMinLength ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
        <span>{{'UserPages.UserChangePassword.PasswordSuggestion1' | translate}}</span>
      </div>
      <div class="requirement-item" [ngClass]="{'fulfilled': hasUpperCase}">
        <i [class]="hasUpperCase ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
        <span>{{'UserPages.UserChangePassword.PasswordSuggestion2' | translate}}</span>
      </div>
      <div class="requirement-item" [ngClass]="{'fulfilled': hasLowerCase}">
        <i [class]="hasLowerCase ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
        <span>{{'UserPages.UserChangePassword.PasswordSuggestion3' | translate}}</span>
      </div>
      <div class="requirement-item" [ngClass]="{'fulfilled': hasNumber}">
        <i [class]="hasNumber ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
        <span>{{'UserPages.UserChangePassword.PasswordSuggestion4' | translate}}</span>
      </div>
    </div>
  </div>
</div>
